import React, { memo } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const ListCard = ({ collection }) => {
  return (
    <div className="max-w-full w-full pl-[10px] md:pl-5 pb-[10px] md:pb-5 box-border">
      <div className="max-w-[70%] w-full mx-auto block border-inherit">
        <Link
          to={`${collection.buttonLink}?vendor=${encodeURIComponent(
            collection.vendor
          )}`}
          className="relative flex rounded-[10px] overflow-hidden transition-[box-shadow] duration-200 ease-in-out bg-[#1f1f1f]
          no-underline border-inherit hover:shadow-3xl"
        >
          <div className="relative w-[30%] pb-[20%] block overflow-hidden">
            {collection.image?.gatsbyImageData && (
              <div className="absolute top-0 left-0 w-full h-full">
                <GatsbyImage
                  image={collection.image.gatsbyImageData}
                  alt={collection.image.title}
                  loading="lazy"
                  className="relative w-full h-full object-cover object-center"
                  objectFit="cover"
                  objectPosition="center"
                />
              </div>
            )}
          </div>
          <div className="static flex flex-col w-3/4 bg-[#f2f2f2] items-start justify-center text-left p-5 md:p-10 inset-0">
            <h2 className="w-[65%] mb-[10px] text-xl md:text-3xl font-bold leading-[30px] md:leading-[45px] tracking-wide text-black">
              {collection.title}
            </h2>
            <div className="w-full flex flex-row-reverse items-center justify-between">
              <Link
                className="hidden md:inline-flex bg-white text-black px-5 py-[5px] -translate-y-[50px] hover:translate-y-[50px] text-[15px] tracking-wider
                rounded-full transition-all duration-200 hover:scale-[1.04]"
                to={`${collection.buttonLink}?vendor=${encodeURIComponent(
                  collection.vendor
                )}`}
              >
                {collection.buttonText}
              </Link>
              <h4 className="text-base md:text-lg font-bold text-black">
                {collection.products} products
              </h4>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default memo(ListCard);
